import { Banner, Body } from '@panwds/react-ui'
import type { BannerProps } from '@panwds/react-ui'
import type { VFC } from 'react'
/**
 *   TODO: Brief what is this component/class do
 */

import { useCallback, useEffect, useRef, useState } from 'react'

const MessageBanner: VFC<{ message: string, doNotCloseBanner: boolean, timerInMilliSec?: number, callBack?: () => {}, bannerProps: BannerProps }> = ({ message, doNotCloseBanner = false, timerInMilliSec = 5000, callBack, bannerProps = {} }) => {

  const timeoutRef: any = useRef()
  const [showBanner, setShowBanner] = useState(false)

  const closeBanner = useCallback(() => {
    setShowBanner(false)
    clearTimeout(timeoutRef.current)
    if (callBack) {
      callBack()
    }
  }, [callBack])

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      !doNotCloseBanner && closeBanner()
    }, timerInMilliSec)
  }, [closeBanner, doNotCloseBanner, timerInMilliSec])

  useEffect(() => {
    if (message) {
      setShowBanner(true)
    }
  }, [message])

  const props = {
    ...bannerProps,
    type: bannerProps.type || 'page',
    appearance: bannerProps.appearance || 'error',
    showIcon: bannerProps.showIcon ?? true,
    ...(!doNotCloseBanner && { onClose: closeBanner })
  }
  return (
    showBanner ? <Banner {...props}>
      <Body addClassName="tw-pb-1 tw-pt-0.5" size="sm">{message}</Body>
    </Banner> : <></>
  )
}

MessageBanner.propTypes = {}

MessageBanner.defaultProps = {
  timerInMilliSec: 5000,
}
export default MessageBanner
